import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const StarOutlinedIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.0693 9.11914L14.1875 9.39551L14.4863 9.4209L19.7754 9.87402L15.7686 13.3311L15.5391 13.5293L15.6084 13.8232L16.8066 18.9639L12.2568 16.2344L12 16.0791L11.7432 16.2344L7.19434 18.9619L8.40039 13.8242L8.46973 13.5293L8.24023 13.3311L4.22852 9.87598L9.5127 9.43066L9.8125 9.40527L9.93066 9.12793L12 4.27344L14.0693 9.11914Z"
            stroke="currentColor"/>
    </svg>


)
const StarOutlinedIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {StarOutlinedIconSvg}
    </SvgIcon>
);
export default StarOutlinedIcon